/**
 * ProfilePermissionsRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { StaffRoleInfo } from './staff_role_info'

/**
 * ProfilePermissionsRes
 */
export interface ProfilePermissionsRes {
  /** 角色列表 */
  roles?: StaffRoleInfo[]
  /** 是否超级管理员 */
  is_super_admin?: boolean
  /** 权限代码列表 */
  permissions?: string[]
}

/**
 * ProfilePermissionsRes Schema
 */
export const ProfilePermissionsResSchema: SchemaDefinition = {
  properties: {
    roles: {
      description: '角色列表',
      format: '[]*entity.StaffRoleInfo',
      items: { $ref: 'StaffRoleInfo', description: '' },
      type: 'array',
      label: '角色列表',
    },
    is_super_admin: {
      description: '是否超级管理员',
      format: 'bool',
      type: 'boolean',
      label: '是否超级管理员',
    },
    permissions: {
      description: '权限代码列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '权限代码列表',
    },
  },
  type: 'object',
}
